/** Legacy opening-session enrichment jobs — hide from the normal Inbox queue. */
export function isOpeningSessionJob(job) {
  const payload = job?.payload;
  if (payload && typeof payload === "object") {
    if (payload.opening_session === true) return true;
    if (payload.channel === "opening_session") return true;
  }
  return false;
}
